export default __webpack_public_path__ + "static/media/ropa-teatro-hombre.fe11d2aa.png";